import { gql } from "@apollo/client";

export const CANCEL_SHIPPOP_ORDER = gql`
  mutation cancelShippopOrder($projectId: ID!, $orderId: ID!) {
    cancelShippopOrder(projectId: $projectId, orderId: $orderId)
  }
`;
